import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { AppWhiteLabelService } from '../../services/app-info-service';
import { AppInfo } from '../../models/app-info';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-app-info',
  templateUrl: './add-app-info.component.html',
  styleUrls: ['./add-app-info.component.scss'],
})
export class AddAppInfoComponent implements OnInit {
  id: number;
  model: AppInfo;
  isEdit = false;
  isLoading = false;
  finishLoading = false;

  // File handling properties
  favIconFormData: FormData;
  loginBackgroundFormData: FormData;
  headerLogoFormData: FormData;
  videoFormData: FormData;
  uploading: boolean;
  webFavIcon: string;
  webHeaderLogo: string;
  mainAppVideoURL: string;

  constructor(
    private diagRef: NbDialogRef<AddAppInfoComponent>,
    private toast: NbToastrService,
    private service: AppWhiteLabelService, // Add your services here
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private route : Router
  ) {}

  ngOnInit(): void {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (!this.isEdit) {
      this.model = {} as AppInfo;

      // Initialize default values
      this.model.mainColor = '#000000';
      this.model.secondaryColor = '#000000';
      this.finishLoading = true;
    } else {
      this.webFavIcon = this.model.webFavIcon;
      this.webHeaderLogo = this.model.webHeaderLogo;
      this.mainAppVideoURL = this.model.mainAppVideoURL;

      // Load existing data
      // this.service.getById(this.id).subscribe(res => {
      //   this.model = res;
      //   this.finishLoading = true;
      // });
    }
  }

  onFavIconChange(event: any) {
    const file = event.target.files[0];
    this.favIconFormData = new FormData();
    this.favIconFormData.append('file', file);
  }

  onLoginBackgroundChange(event: any) {
    const file = event.target.files[0];
    this.loginBackgroundFormData = new FormData();
    this.loginBackgroundFormData.append('file', file);
  }

  onHeaderLogoChange(event: any) {
    const file = event.target.files[0];
    this.headerLogoFormData = new FormData();
    this.headerLogoFormData.append('file', file);
  }

  onVideoChange(event: any) {
    const file = event.target.files[0];
    this.videoFormData = new FormData();
    this.videoFormData.append('file', file);
  }

  save(form: NgForm) {
    if (form.valid) {
      this.isLoading = true;
      // Implement your save logic here
      console.log(this.model);

      this.service
        .post(this.model)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe(() => {
          this.toast.success('تم الحفظ بنجاح', 'نجاح');
          this.diagRef.close('true');
        });
    }
  }

  update() {
    this.isLoading = true;
    // Implement your update logic here
    this.service
      .put(this.id, this.model)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(() => {
        this.toast.success('تم التحديث بنجاح', 'نجاح');
        this.diagRef.close('true');
      });
  }

  closePopup() {
     this.diagRef.close('false');
  }

  async uploadFile(files: FileList, propertyName: string) {
    if (files.length > 0) {
      this.ngZone.run(() => {
        this.uploading = true;
        this.cdr.detectChanges();
      });

      try {
        const formData = new FormData();
        formData.append('file', files[0]);

        // Your file upload API call here
        await this.service.uploadFile(formData).subscribe(
          (response) => {
            // Assuming the response contains the URL of the uploaded file
            const uploadedFileUrl = response.fileName; // Replace with actual response handling
            this.model[propertyName] = uploadedFileUrl;
          },
          (error) => {
            console.log('Failed to upload file', 'Error');
          }
        );
      } catch (error) {
        this.toast.danger('Failed to upload file', 'Error');
      } finally {
        this.ngZone.run(() => {
          this.uploading = false;
          this.cdr.detectChanges();
        });
      }
    }
  }
}
